import type { FindFn } from "@shared/models/analytics/base"

interface Payload {
  planbookId: string
  websiteId: string
  courseId?: string
}

export default function (payload: Payload, findFn: FindFn, userId: string) {
  return {
    classWebsite: findFn("class-website", payload.websiteId),
    planbook: findFn("planbook", payload.planbookId),
    course: payload.courseId ? findFn("course", payload.courseId) : null,
    user: findFn("user", userId),
  }
}
